import { ADD_REQUEST, REMOVE_REQUEST } from "./types";

export const addRequest = requestId => dispatch => {
  dispatch({ type: ADD_REQUEST, payload: requestId });
};

export const removeRequest = requestId => dispatch => {
  dispatch({ type: REMOVE_REQUEST, payload: requestId });
};
